import {APIError} from '../core/errors';
import httpClient from '../services/http.service';
import {BASE_URL, DEFAULT_HEADERS} from './api-constants';
//import {BASE_URL, DEFAULT_HEADERS} from './api-constants';

const _api_base_url = `${BASE_URL}/missingsize/missing-sizes`;
// 'https://run.mocky.io/v3/a94922a3-723d-4112-a4eb-53e15f195ca2';
//  'https://run.mocky.io/v3/293ed9e2-8db4-4241-a5ea-449614d9c427';
//  'https://run.mocky.io/v3/61953380-0497-4260-b5e8-e9d7a373304d';
//  'https://run.mocky.io/v3/fe53d798-9cb7-42c7-90ba-1765f6f50bd4';
//'http://14.142.50.123:7001/BuddyLMREnrolementWS/LSBEnrolement/LSBuddyEnrolDetails';
//TODO: - write the API calls here
interface stocks {
  stockLevel: number;
  stockLevelStatus: string;
}

interface variant2 {
  code: string;
  stock: stocks;
  hasSwatches: boolean;
  isSelected: boolean;
  size: string;
}
interface variant1 {
  code: string;
  stock: stocks;
  color: string;
  colorImageUrl: string;
  hasSwatches: boolean;
  isSelected: boolean;
  varianttype: string;
  variants: variant2[];
}

interface prices {
  currencyIso: string;
  formattedValue: string;
  priceType: string;
  value: number;
}

interface missingSizeReturn {
  name: string;
  price: prices;
  url: string;
  variants: variant1[];
}
interface userPayload {
  payload: {
    itemCode: string;
  };
  accessToken: string;
}

export const getMissingSize = async (
  parameters: userPayload,
): Promise<missingSizeReturn> => {
  //todo
  // dob has to be non mandatory
  try {
    let url = _api_base_url;
    url += `?productCode=${parameters.payload.itemCode}`;

    const response = await httpClient.get(url, {
      headers: {
        ...DEFAULT_HEADERS,
        Authorization: `Bearer ${parameters.accessToken}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error(error);
    throw new APIError(error);
  }
};
